import { ModelEntityWithScores } from '@upright/common/model/output/scores/model-entity-data/types';
import { useCompanyScores } from '@upright/ui/views/model-entity-views/company-view/use-company-scores';
import { compact, flatten, uniqBy } from 'lodash';

export function useCompanyProductNames(companyId: string) {
  const companyScores = useCompanyScores(companyId);
  const productNames = scoreDataToProductNames(companyScores.data);
  return productNames;
}

function scoreDataToProductNames(data?: ModelEntityWithScores | undefined) {
  if (!data) {
    return;
  }
  return uniqBy(flatten(compact(data.modelResults.map(result => result.productNames))), ref => ref.id);
}
